'use strict';
import React, { Component } from 'react';

class PantallaPrincipalTarjetas extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Tarjetas__logo">
            </div>
        );
    }
}

export default PantallaPrincipalTarjetas;